<!-- eslint-disable max-len -->
<template>
  <svg
    id="access-route-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18.25"
  ><path
    d="M17.73 8.36 9.63.26a.9.9 0 0 0-1.27 0l-8.1 8.1a.9.9 0 0 0 0 1.27l8.1 8.1a.9.9 0 0 0 1.27 0l8.1-8.1a.9.9 0 0 0 0-1.27Zm-6.93 2.88V8.99H7.2v2.7H5.4v-3.6c0-.5.41-.9.9-.9h4.5V4.94l3.15 3.15-3.15 3.15Z"
    class="route-fill"
  /></svg>
</template>

<script>
export default {
  name: 'AccessRouteIcon',
};
</script>

<style scoped lang="scss">
.route-fill {
  fill: var(--feature-color, main.$npGray);
}
// eslint-disable-next-line vue-scoped-css/no-unused-selector -- used in parent component
.selected {
  .route-fill {
    fill: #fff;
  }
}
// eslint-disable-next-line vue-scoped-css/no-unused-selector -- used in parent component
.disabled {
  .route-fill {
    fill: darkgrey;
  }
}
</style>
